<template>
    <div>
        <div class="row mt-3">
            <div class="col offset-1"><h5>Add New Channel</h5></div>
        </div>
        <div class="row mt-3">
            <div class="col-2 offset-1">Channel type</div>
            <div class="col-8">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="channel_type" id="phone_radio" @click="newChannel = {}; newChannel['editing'] = true; newChannel['channel_type'] = 'Phone'">
                    <label class="form-check-label" for="phone_radio">Phone</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="channel_type" id="email_radio" @click="newChannel = {}; newChannel['editing'] = true; newChannel['channel_type'] = 'Email'">
                    <label class="form-check-label" for="email_radio">Email</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="channel_type" id="address_radio" @click="newChannel = {}; newChannel['editing'] = true; newChannel['channel_type'] = 'Address'">
                    <label class="form-check-label" for="address_radio">Address</label>
                </div>
            </div>
        </div>
        <div v-if="['Phone', 'Email'].includes(newChannel['channel_type'])" class="row mt-2">
            <div class="col-2 offset-1">
                <label class="col-form-label">{{ newChannel['channel_type'] }} label</label>
            </div>
            <div class="col-8">
                <input v-if="newChannel['channel_type'] == 'Phone'" type="text" class="form-control" :value="newChannel['name']" placeholder="eg. Phone, Cell, Work phone, Mom's phone, etc." @input="e => newChannel['name'] = e.target.value">
                <input v-if="newChannel['channel_type'] == 'Email'" type="text" class="form-control" :value="newChannel['name']" placeholder="eg. Email, Work email, Husband's email, etc." @input="e => newChannel['name'] = e.target.value">
            </div>
        </div>
        <div v-if="['Phone', 'Email'].includes(newChannel['channel_type'])" class="row mt-2">
            <div class="col-2 offset-1">
                <label for="phone_email_address" class="col-form-label">
                    {{ newChannel['channel_type'] }}
                    <span v-if="newChannel['channel_type'] == 'Phone'">number</span>
                    <span v-if="newChannel['channel_type'] == 'Email'">address</span>
                </label>
            </div>
            <div class="col-8">
                <input type="text" id="phone_email_address" class="form-control" :value="newChannel['address']" @input="e => { newChannel['address'] = e.target.value; if (newChannel['channel_type'] === 'Email') { validateEmail(e.target.value); }}">
                <div v-if="emailError" class="text-danger">{{ emailError }}</div>
            </div>
        </div>
        <div v-if="newChannel['channel_type'] == 'Address'" class="row mt-2">
            <div class="col-2 offset-1">
                <label class="col-form-label">Address label</label>
            </div>
            <div class="col-8">
                <input type="text" class="form-control" :value="newChannel['name']" placeholder="eg. Address, Home address, Mailing address, etc."  @input="e => newChannel['name'] = e.target.value">
            </div>
        </div>
        <div v-if="newChannel['channel_type'] == 'Address'" class="row mt-2">
            <div class="col-2 offset-1">
                <label class="col-form-label">Address</label>
            </div>
            <div class="col-8">
                <div class="mb-2">
                    <input type="text" class="form-control" placeholder="Address" :value="newChannel['street1']" @input="e => newChannel['street1'] = e.target.value">
                </div>
                <div class="mb-2">
                    <input type="text" class="form-control" placeholder="Address 2" :value="newChannel['street2']" @input="e => newChannel['street2'] = e.target.value">
                </div>
                <div class="row">
                    <div class="col-8">
                        <input type="text" class="form-control" placeholder="City" :value="newChannel['city']" @input="e => newChannel['city'] = e.target.value">
                    </div>
                    <div class="col-4">
                        <input type="text" class="form-control" placeholder="Zipcode" :value="newChannel['zipcode']" @input="e => newChannel['zipcode'] = e.target.value">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="newChannel['channel_type']" class="row mt-3">
            <div class="col-3 offset-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="is_primary_check" :checked="newChannel['is_primary']" @click="newChannel['is_bad'] = false; newChannel['is_primary'] = true">
                    <label class="form-check-label" for="is_primary_check">Primary</label>
                </div>
            </div>
            <div class="col-5">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="is_bad_check" :checked="newChannel['is_bad']" @click="newChannel['is_primary'] = false; newChannel['is_bad'] = true">
                    <label class="form-check-label" for="is_bad_check">Bad channel</label>
                </div>
            </div>
        </div>
        <div v-if="newChannel['channel_type']" class="row mt-1">
            <div class="col-8 offset-3">
                Notes <textarea class="form-control" id="notes" rows="2" @input="e => newChannel['notes'] = e.target.value">{{ newChannel['notes'] }}</textarea>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col text-center">
                <button v-if="newChannel['channel_type'] && newChannel['name'] && (newChannel['address'] || (newChannel['street1'] && newChannel['zipcode']))" class="btn btn-primary" title="Save" @click="saveChannel();">Save</button>
                <button class="btn btn-secondary ms-3" title="Cancel" @click="newChannel = {}; newChannel['editing'] == false">Cancel</button>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useChannelsStore } from '../../../stores/channels-store'

    const { newChannel } = storeToRefs(useChannelsStore())
    const { storeChannel } = useChannelsStore()
    const emailError = ref('')

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            emailError.value = 'Invalid email address'
            return false
        }
        emailError.value = '' 
        return true
    }

    const saveChannel = () => {
        if (newChannel.value.channel_type === 'Email') {
            if (!validateEmail(newChannel.value.address)) {
                return 
            }
        }
        storeChannel()
    }    
</script>

